import { useState } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { useAlert } from "../../../context/AlertProvider";
import {
  createAccountTeam,
  deleteUserFromTeam,
  getAllTeams,
  updateAccountTeam,
} from "../../../actionCreator/teamManagementActionCreator";

export const useCreateEditTeam = () => {
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  const [error, setError] = useState();
  const [loading, setLoading] = useState();

  const handleCreateUpdateTeam = async (values, initialValues, callback) => {
    setLoading(true);
    setError();

    const res = initialValues?.id
      ? await dispatch(updateAccountTeam({ ...values, id: initialValues?.id }))
      : await dispatch(createAccountTeam(values));

    if (res.status === 201 || res.status === 200) {
      if (initialValues?.id) {
        showAlert(
          "success",
          `${values?.teamName}'s details have been updated successfully!`
        );
      } else {
        showAlert("success", "Team created successfully!");
      }
      callback();
      dispatch(getAllTeams({ page: page ? page - 1 : 0 }));
    } else {
      setError(res?.response?.data?.title);
      showAlert("error", res?.response?.data?.title);
    }
    setLoading(false);
  };

  const handleRemoveUserFromTeam = async (user, callback) => {
    setLoading(true);
    const res = await dispatch(deleteUserFromTeam(user?.id));
    if (res?.status === 204) {
      showAlert("success", `${user?.userName} removed successfully!`);
      callback();
    } else {
      showAlert("error", "Something went wrong. Please try again.");
    }
    setLoading(false);
  };

  return {
    error,
    loading,
    handleCreateUpdateTeam,
    setError,
    handleRemoveUserFromTeam,
  };
};
